import styled from 'styled-components';
import { useShowRevertToDraftBanner } from './hooks/useShowRevertToDraftBanner';
import { RevertToDraftBanner } from './components/RevertToDraftBanner';
import { useShowValidationBanner } from './hooks/useShowValidationBanner';
import { ValidationBanner } from './components/ValidationBanner';
import { ReactElement, ReactNode } from 'react';

const BannerContainer = styled.div`
  position: absolute;
  z-index: 99;
  padding: 40px;
  width: 100%;
`;

export interface WorkflowBannerProps {
  container?: (children: ReactNode) => ReactElement;
}

export function WorkflowBanner({ container }: WorkflowBannerProps) {
  const showValidationBanner = useShowValidationBanner();
  const showRevertToDraft = useShowRevertToDraftBanner();

  if (showValidationBanner) {
    if (container) {
      return container(<ValidationBanner />);
    } else {
      return (
        <BannerContainer id="work-flow-alert">
          <ValidationBanner />
        </BannerContainer>
      );
    }
  }

  if (showRevertToDraft) {
    if (container) {
      return container(<RevertToDraftBanner />);
    } else {
      return (
        <BannerContainer id="work-flow-alert">
          <RevertToDraftBanner />
        </BannerContainer>
      );
    }
  }

  return null;
}
